import i18n from 'i18n';
import {
  CreateProductFormSchemaType,
  generateSubTitle,
  LANG_LIST,
  useGenerateDetailTitle,
} from '../common';
import {
  Control,
  Controller,
  FieldErrors,
  UseFormSetValue,
  useWatch,
} from 'react-hook-form';
import { FormLabel } from '../form-label';
import LOCALS from 'commons/locals';
import { selectGlobalInfo } from 'store/slices/globalInfoSlice';
import { useAppSelector } from 'store/hooks';
import { Input, Tag } from 'antd';
import classNames from 'classnames';

const ProductName = ({
  control,
  errors,
  setValue,
}: {
  control: Control<CreateProductFormSchemaType>;
  errors: FieldErrors<CreateProductFormSchemaType>;
  setValue: UseFormSetValue<CreateProductFormSchemaType>;
}) => {
  const { language, colorSelectOptions } = useAppSelector(selectGlobalInfo);
  const { generateDetailTitle } = useGenerateDetailTitle(control);

  const color = useWatch({
    control,
    name: 'color',
  });

  return (
    <div className="flex gap-2">
      <FormLabel required className="basis-[12.5%]">
        {i18n.t(LOCALS.product_name)}:
      </FormLabel>

      <div className="relative w-full">
        <div className="items-center w-full grid grid-cols-2 gap-y-3 gap-x-8 bg-gray-200 p-3 rounded-md">
          {LANG_LIST.map((lang) => {
            return (
              <div key={lang} className="flex gap-1">
                <Tag
                  color={lang === language ? '#1677ff' : 'default'}
                  className={classNames(
                    'flex items-center justify-center mx-0',
                    language === 'en' ? 'w-40' : 'w-[120px]'
                  )}
                >
                  {i18n.t(lang)}
                </Tag>

                <Controller
                  name={`name.${lang}`}
                  control={control}
                  render={({ field, fieldState }) => {
                    return (
                      <Input
                        {...field}
                        status={fieldState.error ? 'error' : undefined}
                        placeholder={i18n.t(LOCALS.please_enter) || ''}
                        onChange={(e) => {
                          field.onChange(e);
                          const subTitle = generateSubTitle(
                            {
                              en: '',
                              ja: '',
                              zh_CN: '',
                              zh_TW: '',
                              [lang]: e.target.value,
                            },
                            color,
                            colorSelectOptions
                          );
                          setValue(`subTitle.${lang}`, subTitle[lang]);

                          const detailTitle = generateDetailTitle({
                            name: {
                              en: '',
                              ja: '',
                              zh_CN: '',
                              zh_TW: '',
                              [lang]: e.target.value,
                            },
                          });
                          setValue(`detailTitle.${lang}`, detailTitle[lang]);
                        }}
                      />
                    );
                  }}
                ></Controller>
              </div>
            );
          })}
        </div>
        {errors.name && (
          <p style={{ color: 'red' }} className="absolute left-0">
            {i18n.t(LOCALS.required_field)}
          </p>
        )}
      </div>
    </div>
  );
};

export default ProductName;
